import React, { useContext } from 'react';

import { media } from 'context';
import { Icon, Img, Layout, Text } from 'ds';

interface Props {}

const CleaningServiceRevitalizeSpaceCard: React.FC<Props> = () => {
  const { isMobile } = useContext(media);

  if (isMobile) {
    return (
      <Layout padding={24} width="100%" color="blue-50" gap={24} direction="column">
        <Text size={isMobile ? 'headline-xs' : 'headline-md'} color="purple-gradient">
          Revitalize your space
        </Text>
        <Layout direction="row" gap={12}>
          <Layout direction="column" gap={8}>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={isMobile ? 'xxs' : 'xs'} stroke={2} />
              <Text size={isMobile ? 'body-xs' : 'body-sm'}>Floors & surfaces</Text>
            </Layout>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={isMobile ? 'xxs' : 'xs'} stroke={2} />
              <Text size={isMobile ? 'body-xs' : 'body-sm'}>Bathrooms & kitchen</Text>
            </Layout>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={isMobile ? 'xxs' : 'xs'} stroke={2} />
              <Text size={isMobile ? 'body-xs' : 'body-sm'}>General tidying</Text>
            </Layout>
          </Layout>
          <Layout direction="column" gap={8}>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={isMobile ? 'xxs' : 'xs'} stroke={2} />
              <Text size={isMobile ? 'body-xs' : 'body-sm'}>Dishes & trash removal</Text>
            </Layout>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={isMobile ? 'xxs' : 'xs'} stroke={2} />
              <Text size={isMobile ? 'body-xs' : 'body-sm'}>Replenish snacks & beverages</Text>
            </Layout>
          </Layout>
        </Layout>
      </Layout>
    );
  }
  return (
    <Layout direction="row">
      <Layout
        padding={36}
        maxWidth={524}
        color="blue-50"
        borderTopLeftRadius={24}
        borderBottomLeftRadius={16}
        gap={24}
        direction="column"
        flexGrow={1}
      >
        <Text size="headline-md" color="purple-gradient">
          Revitalize your space
        </Text>
        <Layout direction="row" gap={12}>
          <Layout direction="column" gap={8}>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={'xs'} stroke={2} />
              <Text size="body-sm">Floors & surfaces</Text>
            </Layout>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={'xs'} stroke={2} />
              <Text size="body-sm">Bathrooms & kitchen</Text>
            </Layout>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={'xs'} stroke={2} />
              <Text size="body-sm">General tidying</Text>
            </Layout>
          </Layout>
          <Layout direction="column" gap={8}>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={'xs'} stroke={2} />
              <Text size="body-sm">Dishes & trash removal</Text>
            </Layout>
            <Layout direction="row" gap={8} maxWidth={220}>
              <Icon name="checkmark" size={'xs'} stroke={2} />
              <Text size="body-sm">Replenish snacks & beverages</Text>
            </Layout>
          </Layout>
        </Layout>
      </Layout>
      <Layout maxWidth={200}>
        <Img
          srcKey="cleaning_checkout_card_image_WOlMXOA7t.png?updatedAt=1752823051418"
          alt="Revitalize your space"
          width={600}
          height={600}
          folder="ux"
          style={{
            borderTopRightRadius: 16,
            borderBottomRightRadius: 16,
            width: '100%',
            height: '100%'
          }}
        />
      </Layout>
    </Layout>
  );
};

export default CleaningServiceRevitalizeSpaceCard;
